import {ObjectDeleteCommand} from './ObjectDeleteCommand';
import {DeleteWallAction} from '../actions';
import {StageService} from '../../stage.service';
import {RailingGenerationService} from '../../railing/services/railing-generation.service';

interface WallData {
  superstructureType: any;
  distance: any;
  superstructureId: any;
  floor: any;
}

export class DeleteWallCommand extends ObjectDeleteCommand {

  private wallData: WallData;

  constructor(
    stage: StageService,
    private railingGenerationService: RailingGenerationService
  ) {
    super(stage);
  }

  do(action: DeleteWallAction): void {
    super.do(action);
    const wall = this.object;
    const firstPoint = wall.userData.config.firstPoint;
    const {superstructureType, distance, superstructureId, floor} = firstPoint;
    this.wallData = {superstructureType, distance, superstructureId, floor};
    firstPoint.superstructureType = null;
    firstPoint.distance = null;
    firstPoint.superstructureId = null;
    firstPoint.floor = null;
    this.railingGenerationService.buildRailing(this.railingGenerationService.IsVisible());
  }

  undo(): void {
    super.undo();
    const wall = this.object;
    const firstPoint = wall.userData.config.firstPoint;
    const {superstructureType, distance, superstructureId, floor} = this.wallData;
    firstPoint.superstructureType = superstructureType;
    firstPoint.distance = distance;
    firstPoint.superstructureId = superstructureId;
    firstPoint.floor = floor;
    this.railingGenerationService.buildRailing(this.railingGenerationService.IsVisible());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/commands/DeleteWallCommand.ts